// Pulse metric value formatting (Slice 6; docs/phase-0/slice6-component-designs.md §4.1).
//
// `PulseMetricPoint.value` is a bare `z.number()` with no unit metadata on the wire
// (packages/shared/src/model/pulse.ts:45-50) - the component-design spec is explicit that
// each card shows the metric's current value "its own unit - a count/percentage/duration,
// NEVER reformatted as a dollar/token figure regardless of the metric" (component-
// designs.md:404). This formatter is deliberately UNIT-AGNOSTIC: locale-aware grouping/
// decimal formatting only (i18n-localization: "format ... numbers ... through the
// locale"), never an invented %/ms/$ suffix the landed wire does not state.
export const formatMetricValue = (value: number): string =>
  Number.isFinite(value)
    ? new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(value)
    : "—";
